/* INNOR — fiche produit : carte « Compléter l'ensemble ».

   MODÈLE SANS PRODUIT-BUNDLE (décision du 13 août 2026).
   Il n'existe que trois produits — veste, pantalon, jupe. La carte ne
   renvoie plus vers une fiche d'ensemble : elle constitue le panier avec les
   VRAIES pièces, et ce sont des réductions automatiques réglées dans l'Admin
   qui font le prix :

       2 pièces → −30 €  + le pendentif offert
       3 pièces → −45 €  + le pendentif offert

   Ce que ça change par rapport à la version du 12 août :
   - plus de résolution de bundle (bundle_a / bundle_b / bundle_ab), plus de
     verrou « B après A » : sans bundle à faire correspondre, toute
     combinaison est vendable ;
   - la taille de chaque pièce ajoutée se choisit dans la carte, il n'y a
     plus de fiche d'ensemble pour la demander ;
   - le CTA est un bouton qui poste au panier, plus un lien.

   ATTENTION — les montants de remise sont un AFFICHAGE. Le thème ne peut pas
   lire les réductions automatiques de l'Admin : le prix montré ici est une
   promesse que les règles côté Admin doivent tenir. Les deux se règlent
   ensemble, jamais l'un sans l'autre.

   Le pendentif est ajouté au panier à SON PRIX. C'est la règle « 2 pièces →
   pendentif offert » qui le ramène à 0 € — une réduction « Achetez X,
   obtenez Y » ne met rien dans le panier toute seule, elle ne fait que
   remiser ce qui s'y trouve déjà. */
(function () {
  'use strict';

  function money(cents) {
    if (window.INNOR && INNOR.formatMoney) return INNOR.formatMoney(cents);
    var v = cents / 100;   /* même règle que INNOR.formatMoney */
    return (v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
  }

  function cents(root, key) {
    return parseInt(root.dataset[key], 10) || 0;
  }

  /* Même piège que pour les messages de la jauge : data-ensemble-discount-2
     se lit « ensembleDiscount-2 » dans dataset (un tiret suivi d'un CHIFFRE
     n'est pas camelCasé), donc dataset.ensembleDiscount2 valait undefined et
     la remise tombait à 0. Conséquence restée invisible jusqu'au 13 août :
     la carte affichait la somme des pièces SANS les −30/−45 € et annonçait
     une économie amputée d'autant. Lecture par getAttribute. */
  function attrCents(root, name) {
    return parseInt(root.getAttribute(name), 10) || 0;
  }

  function pieces(root) {
    return {
      current: root.querySelector('[data-ensemble-toggle="current"]'),
      a: root.querySelector('[data-ensemble-toggle="a"]'),
      b: root.querySelector('[data-ensemble-toggle="b"]')
    };
  }

  /* Le variant de la pièce affichée vient du formulaire d'achat standard :
     sa grille de tailles reste visible même quand on compose un ensemble
     (voir main-product.liquid), donc c'est elle qui fait foi — dupliquer un
     sélecteur pour cette pièce dans la carte laisserait deux tailles
     concurrentes à l'écran. */
  function currentVariant() {
    var form = document.querySelector('[data-ensemble-current-form]');
    if (!form) return null;
    var checked = form.querySelector('input[name="id"]:checked');
    if (checked) return parseInt(checked.value, 10);
    /* Pas de repli sur le premier bouton radio venu : la grille ne
       présélectionne rien quand la première taille est épuisée, et prendre
       « le premier » enverrait au panier une taille indisponible que
       personne n'a choisie. Mieux vaut rendre la main au visiteur. */
    var only = form.querySelector('input[name="id"][type="hidden"]');
    return only ? parseInt(only.value, 10) : null;
  }

  /* LES TAILLES NE SONT PLUS DANS LA CARTE (14 août) : elles sont regroupées
     sous elle, avec celle du produit affiché, dans [data-ensemble-sizes].
     Toutes les lectures de taille passent donc par ce conteneur et non par la
     carte. Le repli sur `root` couvre le cas d'une fiche restée à l'ancienne
     disposition ; la fenêtre d'upsell, elle, garde ses propres pastilles et
     appelle ces fonctions avec sa propre racine. */
  function sizesRoot(root) {
    return document.querySelector('[data-ensemble-sizes]') || root;
  }

  /* [data-ensemble-size] désigne soit un input caché (pièce à taille unique),
     soit le GROUPE de pastilles (pièce taillée) — d'où les deux lectures. */
  function sizeField(root, key) {
    return root.querySelector('[data-ensemble-size="' + key + '"]');
  }

  function sizeValue(root, key) {
    var field = sizeField(root, key);
    if (!field) return NaN;
    if (field.tagName === 'INPUT') return parseInt(field.value, 10);
    var picked = field.querySelector('input:checked');
    return picked ? parseInt(picked.value, 10) : NaN;
  }

  function clearSize(root, key) {
    var field = sizeField(root, key);
    if (!field || field.tagName === 'INPUT') return;
    field.querySelectorAll('input:checked').forEach(function (input) {
      input.checked = false;
    });
  }

  function update(root) {
    var t = pieces(root);
    var label = root.querySelector('[data-ensemble-label]');
    var sumEl = root.querySelector('[data-ensemble-sum]');
    var totalPriceEl = root.querySelector('[data-ensemble-total-price]');
    var cta = document.querySelector('[data-ensemble-cta]');
    var ctaPrice = cta ? cta.querySelector('[data-ensemble-cta-price]') : null;
    var soloCta = document.querySelector('[data-ensemble-solo-cta]');
    var errorEl = document.querySelector('[data-ensemble-error]');

    var aOn = !!(t.a && t.a.checked);
    var bOn = !!(t.b && t.b.checked);
    var extra = (aOn ? 1 : 0) + (bOn ? 1 : 0);

    /* LA PIÈCE AFFICHÉE N'EST PLUS ACQUISE D'AVANCE (02/09/2026).
       Le compte valait `1 + extra` : la fiche s'ouvrait sur « 1 pièce » et
       une jauge déjà entamée, parce que la première taille était cochée
       d'office. La fiche est devenue généraliste — plus rien n'est
       présélectionné — donc la pièce affichée ne compte que lorsque sa
       taille est réellement choisie. Départ à 0, comme le reste. */
    /* LA VESTE EST UN VRAI TROISIÈME CHOIX (02/09/2026, correctif). Elle
       comptait dès qu'une taille était prise dans une grille TOUJOURS
       affichée — c'était la grille elle-même qui restait active par défaut,
       seule des trois. `currentOn` suit maintenant SA case à cocher, comme
       aOn et bOn suivent les leurs ; la grille de tailles ne s'affiche
       qu'une fois cette case cochée (voir plus bas dans cette fonction). */
    var currentToggle = t.current;
    var currentOn = !!(currentToggle && currentToggle.checked);
    var total = (currentOn ? 1 : 0) + extra;

    var currentWrap = document.querySelector('[data-ensemble-size-wrap="current"]');
    if (currentWrap) {
      currentWrap.hidden = !currentOn;
      if (!currentOn) {
        currentWrap.querySelectorAll('input[name="id"]:checked').forEach(function (input) {
          input.checked = false;
        });
      }
    }

    if (errorEl) errorEl.textContent = '';
    if (label) {
      label.textContent = total === 0
        ? 'Aucune pièce sélectionnée'
        : total + (total > 1 ? ' pièces' : ' pièce');
    }

    /* Une taille ne se demande qu'une fois la pièce cochée : ouvrir les trois
       grilles d'emblée ferait ouvrir la fiche sur un formulaire, dont deux
       tiers ne servent à rien tant qu'on n'a rien choisi. */
    var sizes = sizesRoot(root);
    ['a', 'b'].forEach(function (key) {
      var wrap = sizes.querySelector('[data-ensemble-size-wrap="' + key + '"]');
      if (!wrap) return;
      var on = key === 'a' ? aOn : bOn;
      wrap.hidden = !on;
      if (!on) clearSize(sizes, key);
    });

    /* LE PENDENTIF NE S'AFFICHE DANS LA CARTE QUE DÉBLOQUÉ (14 août).

       Il y vivait dans les deux états. À l'ouverture de la fiche, sa rangée
       ne disait donc que le manque — « Le cadeau de l'ensemble / Silver
       Signature / Encore une pièce et il est à vous » — juste sous des
       pièces qu'on peut avoir tout de suite. Le client l'a fait retirer :
       tant que rien n'est coché, la promesse est portée par la tête de la
       jauge (bandeau photo + valeur), et la carte ne montre que de l'achetable.

       Dès qu'une pièce est cochée, la rangée revient — mais directement à
       l'état débloqué : aplat rouge, prix barré, sceau OFFERT. C'est une
       récompense qui tombe, plus un manque qui patiente. */
    var giftRow = root.querySelector('[data-ensemble-gift-row]');
    var giftPlus = root.querySelector('[data-ensemble-gift-plus]');
    var giftState = root.querySelector('[data-ensemble-gift-state]');
    var giftWas = root.querySelector('[data-ensemble-gift-was]');
    var giftBadge = root.querySelector('[data-ensemble-gift-badge]');
    var sumGift = cents(root, 'ensembleSumGift');
    /* Le cadeau tombe à DEUX pièces, ce que dit la règle de l'Admin. Il se
       débloquait dès qu'une case était cochée, ce qui était juste tant que la
       pièce affichée comptait toujours pour une : cocher A faisait bien deux.
       Maintenant que rien n'est acquis, il faut compter pour de vrai. */
    var unlocked = total >= 2;

    if (giftRow) {
      giftRow.hidden = !unlocked;
      if (giftPlus) giftPlus.hidden = !unlocked;
      giftRow.classList.toggle('is-unlocked', unlocked);
      if (giftState) giftState.textContent = 'Débloqué, il part avec votre ensemble';
      if (giftWas) giftWas.hidden = !unlocked;
      /* « OFFERT » en capitales : c'est un sceau, pas une phrase. Le prix
         barré juste à côté lui donne son échelle — « offert » sans montant en
         face ne pèse rien. */
      if (giftBadge) giftBadge.textContent = unlocked ? 'OFFERT' : money(sumGift);
    }

    /* LA JAUGE DE PALIERS. Elle est mise à jour AVANT le retour anticipé du
       cas « aucune pièce cochée » : à 1 pièce, elle doit déjà montrer le
       chemin restant — c'est là qu'elle sert, pas une fois l'ensemble fait.

       Le remplissage se compte en INTERVALLES, pas en pièces : à 1 pièce sur
       3 paliers la barre est vide (0 palier franchi), à 2 elle est à moitié,
       à 3 elle est pleine. Un remplissage en total/steps laisserait un tiers
       de barre colorée d'entrée de jeu, ce qui ne récompense rien. */
    var gauge = document.querySelector('[data-ensemble-gauge]');
    if (gauge) {
      var steps = parseInt(gauge.dataset.gaugeSteps, 10) || 1;
      var reached = Math.min(total, steps);
      /* Le remplissage part de ZÉRO pièce et non d'une pièce acquise. La
         formule (reached-1)/(steps-1) donnait -50 % à 0 pièce, donc une barre
         vide par accident plutôt que par calcul, et un premier palier déjà
         franchi à l'ouverture. En reached/steps, chaque pièce ajoute sa part
         et la barre se remplit vraiment au fil du choix. */
      var pct = (reached / steps) * 100;
      var fill = gauge.querySelector('[data-ensemble-gauge-fill]');
      if (fill) fill.style.width = pct + '%';
      gauge.classList.toggle('is-max', reached >= steps);
      /* La jauge « trop neutre » (retour du 14 août) tient à deux choses :
         rien n'y désignait le PROCHAIN palier, et le cadeau n'y était qu'un
         mot. is-next répond à la première (la pastille suivante s'entoure de
         rouge, sa récompense cesse d'être grisée) ; la seconde est réglée par
         le bandeau ci-dessous, qui montre l'objet et sa valeur. */
      gauge.querySelectorAll('[data-gauge-step]').forEach(function (step) {
        var n = parseInt(step.dataset.gaugeStep, 10);
        step.classList.toggle('is-done', n <= reached);
        step.classList.toggle('is-current', n === reached);
        step.classList.toggle('is-next', n === reached + 1);
      });

      /* Le bandeau cadeau en tête de jauge ne vit que tant que rien n'est
         coché : passé la première pièce, le cadeau est revenu dans la carte,
         à l'état débloqué. Deux fois le même pendentif à l'écran, ce serait
         une promesse qui bafouille. */
      var gaugeGift = gauge.querySelector('[data-ensemble-gauge-gift]');
      if (gaugeGift) gaugeGift.hidden = unlocked;
      gauge.classList.toggle('is-idle', !unlocked);
      /* getAttribute, pas dataset : un tiret suivi d'un CHIFFRE n'est pas
         camelCasé (data-gauge-msg-1 → clé « gaugeMsg-1 », pas « gaugeMsg1 »).
         Lu par dataset.gaugeMsg1, le message revenait toujours vide. */
      var gaugeMsg = gauge.querySelector('[data-ensemble-gauge-msg]');
      if (gaugeMsg) gaugeMsg.textContent = gauge.getAttribute('data-gauge-msg-' + reached) || '';

      /* TENUE COMPLÈTE : on note l'état, on n'annonce rien ici.

         Le ticket s'ouvrait autrefois dès que la troisième pièce était COCHÉE.
         Erreur : à cet instant le panier est encore vide, et le bouton
         « Appliquer la remise » posait donc un code sur un panier inexistant —
         le client tombait sur une caisse vide. Corrigé le 15/08/2026 : le
         ticket part APRÈS l'ajout au panier (voir plus bas), quand il y a
         vraiment quelque chose à réduire. Ce drapeau ne sert plus qu'à savoir
         si l'ajout portait bien la tenue complète. */
      var complet = reached >= steps;

      /* La carte de la seconde récompense suit l'état, pas la transition :
         elle doit rester visible tant que les trois pièces sont cochées,
         contrairement au ticket qui, lui, ne s'ouvre qu'une fois. */
      var surpriseRow = root.querySelector('[data-ensemble-surprise-row]');
      if (surpriseRow) surpriseRow.hidden = !complet;

      if (complet) { root.dataset.ensembleComplet = '1'; }
      else { delete root.dataset.ensembleComplet; }
    }

    var sumCurrent = cents(root, 'ensembleSumCurrent');
    var sumA = cents(root, 'ensembleSumA');
    var sumB = cents(root, 'ensembleSumB');

    /* Aucune pièce : la carte n'affiche pas de prix, il n'y a rien à
       chiffrer. Elle en affichait un — celui de la pièce de la page — alors
       que le visiteur n'a encore rien choisi. */
    if (total === 0) {
      if (sumEl) sumEl.hidden = true;
      if (totalPriceEl) totalPriceEl.textContent = '…';
      if (cta) cta.hidden = true;
      if (soloCta) soloCta.hidden = false;
      return;
    }

    /* Une seule pièce, quelle qu'elle soit : pas de palier, prix nu. Le
       parcours « pièce seule » garde le bouton du formulaire. */
    if (total === 1) {
      var seule = currentOn ? sumCurrent : (aOn ? sumA : sumB);
      if (sumEl) sumEl.hidden = true;
      if (totalPriceEl) totalPriceEl.textContent = money(seule);
      if (cta) cta.hidden = currentOn;
      if (soloCta) soloCta.hidden = !currentOn;
      if (cta && !currentOn && ctaPrice) ctaPrice.textContent = money(seule);
      return;
    }

    /* Le palier suit le NOMBRE de pièces, pas leur identité — c'est tout
       l'intérêt du modèle retenu : une seule règle par palier au lieu d'une
       par combinaison. Contrepartie assumée le 13 août : le Duo tombe à
       285 € au lieu de 290, un palier unique ne pouvant pas donner −25 sur
       veste+jupe et −30 sur veste+pantalon à la fois. */
    var discount = total === 2
      ? attrCents(root, 'data-ensemble-discount-2')
      : attrCents(root, 'data-ensemble-discount-3');

    /* Valeur catalogue (prix barré) : les pièces retenues PLUS le pendentif,
       qui compte pour ce qu'il vaut. L'omettre ferait afficher 30 €
       d'économie là où le client en reçoit 110. */
    var rawSum = (currentOn ? sumCurrent : 0) + (aOn ? sumA : 0) + (bOn ? sumB : 0) + sumGift;
    /* Prix réellement payé : le pendentif n'y entre pas, il est offert. */
    var payable = (currentOn ? sumCurrent : 0) + (aOn ? sumA : 0) + (bOn ? sumB : 0) - discount;

    if (sumEl) { sumEl.hidden = false; sumEl.textContent = money(rawSum); }
    if (totalPriceEl) totalPriceEl.textContent = money(payable);

    /* Plus de ligne « Vous économisez X » (retirée le 13 août, jugée
       « cheap ») : le prix barré face au prix payé porte déjà l'écart. */

    if (cta) {
      cta.hidden = false;
      if (ctaPrice) ctaPrice.textContent = money(payable);
    }
    if (soloCta) soloCta.hidden = true;
  }

  /* Constitution du panier. Une pièce cochée sans taille bloque l'envoi :
     mieux vaut un message sous le bouton qu'une commande partie avec une
     taille par défaut que personne n'a choisie. */
  /* Propriétés de ligne du formulaire produit (précommande : délai annoncé,
     consentement horodaté). Elles sont recopiées sur CHAQUE pièce de
     l'ensemble — cadeau compris : toutes partent dans le même envoi, donc
     toutes attendent la même date. */
  function formProperties() {
    var form = document.querySelector('[data-ensemble-current-form]');
    if (!form) return null;
    var props = {};
    new FormData(form).forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') props[match[1]] = value;
    });
    return Object.keys(props).length ? props : null;
  }

  function collect(root) {
    var t = pieces(root);
    var items = [];
    var missing = [];

    /* LA PIÈCE DE LA FICHE EST REDEVENUE OPTIONNELLE (02/09/2026, correctif).
       Cette fonction exigeait une taille du produit affiché AVANT MÊME de
       regarder ce qui était coché : cocher uniquement la jupe ou le pantalon
       échouait toujours avec « Choisissez une taille », pour une taille que
       personne n'avait demandé de choisir. C'était le bug réel derrière
       « je ne peux pas sélectionner ce que je veux » — pas une limite du
       modèle, une ligne de trop.

       On ne pousse le produit affiché QUE si une taille lui a été donnée
       (currentOn, mêmes helpers que dans update()) ; sinon on continue sans
       lui, comme pour a et b. L'erreur ne sort plus qu'à la fin, et
       seulement si RIEN n'est réellement sélectionnable. */
    /* CORRECTIF (22/09/2026) : la pièce affichée était retirée EN SILENCE.

       Le 02/09 on l'a rendue optionnelle pour débloquer « je coche seulement
       le pantalon ». Mais la condition retenue (`if (current)`) ne distingue
       pas « je n'en veux pas » de « j'ai oublié sa taille » : dans les deux
       cas elle disparaît sans un mot.

       Constaté en production le 22/09 : case de la veste cochée (elle l'est
       d'office), aucune taille donnée, le bouton annonce « AJOUTER
       L'ENSEMBLE, 400 € » et le panier ne reçoit que le pantalon à 180 €.
       Sans message, et sans le pendentif puisqu'il en faut deux.

       C'est la CASE qui tranche, pas la taille : décochée, on continue sans
       elle exactement comme avant (le correctif du 02/09 tient) ; cochée
       sans taille, elle rejoint `missing` et sort la même erreur que a et b.
       Elle est poussée AVANT la boucle pour que la phrase nomme les pièces
       dans l'ordre où elles sont à l'écran. */
    var current = currentVariant();
    if (current) {
      items.push({ id: current, quantity: 1 });
    } else if (t.current && t.current.checked) {
      var currentWrap = document.querySelector('[data-ensemble-size-wrap="current"]');
      missing.push(
        currentWrap && currentWrap.dataset.pieceName
          ? currentWrap.dataset.pieceName
          : 'une pièce'
      );
    }

    var sizes = sizesRoot(root);
    [['a', t.a], ['b', t.b]].forEach(function (pair) {
      var key = pair[0];
      var toggle = pair[1];
      if (!toggle || !toggle.checked) return;
      var value = sizeValue(sizes, key);
      if (!value) {
        /* Le nom nu vient de data-piece-name : le libellé affiché est
           contracté (« Taille de la Jupe ») et se relirait mal dans la
           phrase d'erreur. */
        var wrap = sizes.querySelector('[data-ensemble-size-wrap="' + key + '"]');
        missing.push(wrap && wrap.dataset.pieceName ? wrap.dataset.pieceName : 'une pièce');
        return;
      }
      items.push({ id: value, quantity: 1 });
    });

    /* Rien de coché ET la pièce affichée sans taille : il n'y a littéralement
       rien à ajouter. Ce cas ne devrait pas arriver — le CTA de l'ensemble
       est masqué à 0 pièce — mais un clic programmatique ou une course entre
       deux mises à jour ne doit pas partir avec un panier vide. */
    if (!items.length && !missing.length) {
      return { error: 'Choisissez au moins une pièce.' };
    }

    if (missing.length) {
      return { error: 'Choisissez une taille pour : ' + missing.join(', ') + '.' };
    }

    /* LE PENDENTIF NE PART QU'À PARTIR DE DEUX PIÈCES (25/08/2026).

       Il partait à CHAQUE ajout, y compris quand aucune autre pièce n'était
       cochée : acheter la veste seule depuis cette carte mettait le Silver
       Signature au panier, à 80 €, sans qu'aucune réduction ne vienne
       l'annuler — la règle de l'Admin demande deux pièces. C'est l'un des
       « colis offerts avec une seule veste » signalés.

       `items` ne contient que des PIÈCES à cet endroit : la pièce affichée,
       plus celles qui sont cochées. Deux, c'est le palier.

       Le panier peut déjà contenir une autre pièce, auquel cas ce seuil est
       trop prudent — c'est innor-panier.js qui rattrape, en vérifiant la
       règle sur le panier entier après chaque changement. Ici on se contente
       de ne jamais créer la faute. */
    var giftId = parseInt(root.dataset.ensembleGiftVariant, 10);
    var giftItem = null;
    if (giftId && items.length >= 2) {
      giftItem = { id: giftId, quantity: 1 };
      items.push(giftItem);
    }

    var props = formProperties();
    if (props) {
      items.forEach(function (item) { item.properties = props; });
    }
    /* Marqueur posé APRÈS formProperties() : le pendentif offert doit garder
       les propriétés de précommande comme les autres lignes, mais c'est aussi
       LUI, et lui seul ici, que innor-panier.js doit reconnaître comme cadeau
       pour sa réconciliation — un pendentif payé séparément (achat seul,
       offre Duo) n'a jamais cette propriété. Voir CLE_MARQUEUR_CADEAU dans
       innor-panier.js : même clé, à tenir synchronisée si elle change. */
    if (giftItem) {
      giftItem.properties = Object.assign({}, giftItem.properties, { '_Cadeau ensemble': 'oui' });
    }

    return { items: items };
  }

  function bind(root) {
    var t = pieces(root);
    [t.current, t.a, t.b].forEach(function (input) {
      if (input) input.addEventListener('change', function () { update(root); });
    });
    var sizes = sizesRoot(root);
    ['a', 'b'].forEach(function (key) {
      var field = sizeField(sizes, key);
      if (field) field.addEventListener('change', function () { update(root); });
    });

    /* LA TAILLE DE LA PIÈCE AFFICHÉE COMPTE MAINTENANT DANS LE TOTAL
       (02/09/2026), il faut donc l'écouter. Elle ne l'était pas : tant
       qu'elle était cochée d'office, elle ne changeait jamais l'état de la
       jauge. Depuis que rien n'est présélectionné, la choisir fait passer de
       0 à 1 pièce — sans cet écouteur, la carte resterait à « Aucune pièce »
       après un vrai choix. L'écouteur est posé sur le FORMULAIRE, pas sur
       chaque input : les boutons radio y sont rendus par une boucle Liquid et
       l'événement change remonte. */
    var form = document.querySelector('[data-ensemble-current-form]');
    if (form) form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') update(root);
    });

    var cta = document.querySelector('[data-ensemble-cta]');
    var errorEl = document.querySelector('[data-ensemble-error]');
    if (cta) {
      cta.addEventListener('click', async function () {
        var result = collect(root);
        if (errorEl) errorEl.textContent = '';
        if (result.error) {
          if (errorEl) errorEl.textContent = result.error;
          return;
        }
        var label = cta.querySelector('[data-ensemble-cta-label]');
        var before = label ? label.textContent : '';
        cta.disabled = true;
        if (label) label.textContent = 'Ajout…';
        try {
          await INNOR.cart.addMany(result.items);
          /* Tenue complète : le ticket prend la place du panneau panier. Les
             deux ensemble se superposeraient, et le ticket a priorité — il
             mène au paiement, le panneau n'y mène qu'après un clic de plus.
             Le panneau s'ouvre quand même à la fermeture du ticket, pour ne
             pas laisser le client sans repère. */
          /* L'événement est ANNULABLE, et c'est ce qui rend l'enchaînement
             sûr : le ticket appelle preventDefault s'il s'ouvre vraiment.
             Sans ça, une tenue complète dont le ticket a déjà été vu dans la
             session n'ouvrait plus RIEN — ni ticket, ni panneau — et le client
             restait sur la fiche sans savoir que son ensemble était parti au
             panier. Régression constatée par le client le 15/08. */
          var pris = false;
          if (root.dataset.ensembleComplet === '1') {
            var ev = new CustomEvent('innor:ensemble-complet', { cancelable: true });
            pris = !document.dispatchEvent(ev);
          }
          if (!pris && INNOR.panels) {
            INNOR.panels.open('[data-cart-panel]');
          }
        } catch (err) {
          if (errorEl) errorEl.textContent = err.message;
        } finally {
          cta.disabled = false;
          if (label) label.textContent = before;
        }
      });
    }

    update(root);
  }

  /* ============================================================
     FENÊTRE D'UPSELL — « il vous manque une pièce » (14 août 2026)
     ============================================================
     Elle s'ouvre à la place du panneau panier quand une pièce vient d'être
     ajoutée SEULE, alors qu'une carte d'ensemble était sous les yeux. Le
     visiteur a dit oui au vêtement ; il n'a pas dit non au pendentif, il ne
     l'a simplement pas vu comme atteignable. C'est le dernier instant où on
     peut le lui montrer sans le retenir de force.

     Trois garde-fous, parce qu'un upsell qui insiste vend moins qu'un upsell
     qui se tait :
       - une seule ouverture par page (upsellShown) ;
       - jamais si une pièce de l'ensemble est cochée (ce parcours-là a son
         propre bouton, la fenêtre n'aurait rien à ajouter) ;
       - jamais si le pendentif est déjà au panier.

     Elle ajoute la deuxième pièce ET le pendentif en un seul appel : deux
     pièces au panier, donc les réductions automatiques de l'Admin
     s'appliquent (−30 € et pendentif à 0 €). Comme partout ailleurs, ces
     montants sont une promesse d'affichage que les règles de l'Admin doivent
     tenir. */
  var upsellShown = false;

  function upsell(card) {
    var modal = document.querySelector('[data-upsell]');
    var configEl = document.querySelector('[data-upsell-config]');
    if (!modal || !configEl) return;

    var config = {};
    try { config = JSON.parse(configEl.textContent); } catch (err) { config = {}; }
    var giftId = parseInt(config.gift, 10);
    if (!giftId) return;

    var addBtn = modal.querySelector('[data-upsell-add]');
    var addLabel = modal.querySelector('[data-upsell-add-label]');
    var errorEl = modal.querySelector('[data-upsell-error]');
    var gaugeEl = modal.querySelector('[data-ensemble-gauge]');
    var gaugeSteps = gaugeEl ? (parseInt(gaugeEl.dataset.gaugeSteps, 10) || 1) : 1;
    var lastFocus = null;

    /* SÉLECTION MULTIPLE (01/09/2026). C'était un `querySelector` sur un
       groupe de boutons radio : « la jupe OU le pantalon ». Or les deux sont
       achetables ensemble, et c'est même la combinaison la plus rentable —
       trois pièces au panier déclenchent le palier −45 € au lieu de −30 €.
       Les cases sont devenues des checkbox côté Liquid, la lecture devient
       donc une liste. */
    function chosenAll() {
      return Array.prototype.slice.call(
        modal.querySelectorAll('[data-upsell-piece]:checked')
      );
    }

    /* Le bouton dit toujours ce qu'il manque pour l'activer : « choisissez
       une pièce », puis « choisissez une taille », puis le prix. Un bouton
       désactivé et muet laisse croire à une panne. */
    function refresh() {
      var picked = chosenAll();
      var keys = picked.map(function (input) { return input.value; });

      /* Une grille de tailles par pièce cochée, et seulement pour celles-là.
         Les deux peuvent être ouvertes en même temps depuis le 01/09. */
      ['a', 'b'].forEach(function (k) {
        var wrap = modal.querySelector('[data-ensemble-size-wrap="' + k + '"]');
        var on = keys.indexOf(k) !== -1;
        if (wrap) wrap.hidden = !on;
        if (!on) clearSize(modal, k);
      });

      /* LA JAUGE SUIT LE NOMBRE DE PIÈCES QUI SERONT AU PANIER : celle déjà
         ajoutée (toujours 1, cette fenêtre ne s'ouvre qu'après un ajout
         solo) plus celles cochées ici. Même calcul, mêmes classes que la
         jauge de la carte « Compléter la tenue » (voir update() plus haut) —
         seule la racine change, modal au lieu du formulaire de la fiche. */
      if (gaugeEl) {
        var reached = Math.min(1 + keys.length, gaugeSteps);
        var pct = (reached / gaugeSteps) * 100;
        var fill = gaugeEl.querySelector('[data-ensemble-gauge-fill]');
        if (fill) fill.style.width = pct + '%';
        gaugeEl.classList.toggle('is-max', reached >= gaugeSteps);
        gaugeEl.querySelectorAll('[data-gauge-step]').forEach(function (step) {
          var n = parseInt(step.dataset.gaugeStep, 10);
          step.classList.toggle('is-done', n <= reached);
          step.classList.toggle('is-current', n === reached);
          step.classList.toggle('is-next', n === reached + 1);
        });
        /* NE JAMAIS CACHER LE CADEAU ICI (corrigé 03/09/2026). Sur la carte
           « Compléter la tenue », le bandeau se cache une fois débloqué parce
           qu'une carte séparée (giftRow, voir update() plus haut) prend le
           relais pour montrer le pendentif à l'état obtenu. Cette fenêtre n'a
           pas cette carte de relais : cacher le bandeau ne laissait plus rien
           à l'écran, le pendentif semblait disparaître dès la 2e pièce cochée. */
        var gaugeGift = gaugeEl.querySelector('[data-ensemble-gauge-gift]');
        if (gaugeGift) gaugeGift.hidden = false;
        gaugeEl.classList.toggle('is-idle', !keys.length);
        var gaugeMsg = gaugeEl.querySelector('[data-ensemble-gauge-msg]');
        if (gaugeMsg) gaugeMsg.textContent = gaugeEl.getAttribute('data-gauge-msg-' + reached) || '';
      }

      if (!keys.length) {
        if (addLabel) addLabel.textContent = 'Choisissez une pièce';
        if (addBtn) addBtn.disabled = true;
        return;
      }

      /* Le bouton nomme la pièce qui bloque, pas « une taille » : avec deux
         grilles ouvertes, un message générique ne dit pas laquelle remplir. */
      var manque = keys.filter(function (k) { return !sizeValue(modal, k); });
      if (manque.length) {
        var noms = manque.map(function (k) {
          var wrap = modal.querySelector('[data-ensemble-size-wrap="' + k + '"]');
          return (wrap && wrap.dataset.pieceName) ? wrap.dataset.pieceName : 'la pièce';
        });
        if (addLabel) addLabel.textContent = 'Choisissez une taille pour : ' + noms.join(', ');
        if (addBtn) addBtn.disabled = true;
        return;
      }

      var price = picked.reduce(function (sum, input) {
        return sum + (parseInt(input.getAttribute('data-upsell-price'), 10) || 0);
      }, 0);
      if (addLabel) addLabel.textContent = 'Ajouter et recevoir le cadeau · ' + money(price);
      if (addBtn) addBtn.disabled = false;
    }

    function close(openCart) {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      INNOR.lockScroll(false);
      if (openCart && INNOR.panels) INNOR.panels.open('[data-cart-panel]');
      else if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    /* FERMER OUVRE LE PANIER (01/09/2026). Croix, scrim, Échap et « non
       merci » menaient tous à close(false) : la fenêtre disparaissait et le
       client se retrouvait sur la fiche, sans rien qui confirme que sa pièce
       était bien partie au panier — il venait pourtant de l'acheter.
       Refuser l'upsell n'est pas annuler l'achat. */
    function onKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(true); }
    }

    function open() {
      upsellShown = true;
      lastFocus = document.activeElement;
      modal.hidden = false;
      INNOR.lockScroll(true);
      document.addEventListener('keydown', onKey);
      refresh();
      var first = modal.querySelector('[data-upsell-piece]');
      if (first) first.focus({ preventScroll: true });
    }

    modal.addEventListener('change', refresh);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-close]')) close(true);
    });

    if (addBtn) {
      addBtn.addEventListener('click', async function () {
        var picked = chosenAll();
        if (!picked.length) return;
        if (errorEl) errorEl.textContent = '';
        var items = [];
        var manque = false;
        picked.forEach(function (input) {
          var variant = sizeValue(modal, input.value);
          if (!variant) { manque = true; return; }
          items.push({ id: variant, quantity: 1 });
        });
        if (manque || !items.length) {
          if (errorEl) errorEl.textContent = 'Choisissez une taille.';
          return;
        }
        var giftItem = { id: giftId, quantity: 1 };
        items.push(giftItem);
        /* Mêmes propriétés de ligne que l'ajout qui vient d'avoir lieu
           (précommande, consentement horodaté) : ces pièces partent dans le
           même envoi, elles ne peuvent pas raconter autre chose. */
        var props = formProperties();
        if (props) items.forEach(function (item) { item.properties = props; });
        /* + le marqueur de cadeau (même clé que innor-panier.js et l'autre
           chemin plus haut) : sans lui, la réconciliation du tiroir ne
           distingue plus ce pendentif offert d'un pendentif payé séparément. */
        giftItem.properties = Object.assign({}, giftItem.properties, { '_Cadeau ensemble': 'oui' });

        var before = addLabel ? addLabel.textContent : '';
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Ajout…';
        try {
          await INNOR.cart.addMany(items);
          /* TICKET MYSTÈRE MANQUANT DEPUIS CETTE FENÊTRE (corrigé 03/09/2026).
             Cocher les deux pièces ici complète pourtant la tenue (1 pièce
             déjà au panier + les 2 cochées = gaugeSteps) exactement comme sur
             la carte « Compléter la tenue », mais rien ne dispatchait
             `innor:ensemble-complet` : le client qui complétait sa tenue
             depuis cette fenêtre n'avait jamais le ticket. Même contrat que
             la carte — événement annulable, le panneau panier ne prend la
             main que si le ticket ne s'est pas montré (déjà vu dans la
             session, ou tenue incomplète). */
          var reached = Math.min(1 + picked.length, gaugeSteps);
          var pris = false;
          if (reached >= gaugeSteps) {
            var ev = new CustomEvent('innor:ensemble-complet', { cancelable: true });
            pris = !document.dispatchEvent(ev);
          }
          close(!pris);
        } catch (err) {
          if (errorEl) errorEl.textContent = err.message;
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = before;
        }
      });
    }

    /* Le noyau annonce chaque ajout au panier et laisse la main : annuler
       l'événement, c'est prendre en charge la suite à sa place (il n'ouvrira
       pas le panneau panier). */
    document.addEventListener('innor:added', function (e) {
      if (upsellShown) return;
      var t = pieces(card);
      if ((t.a && t.a.checked) || (t.b && t.b.checked)) return;
      var state = INNOR.cart && INNOR.cart.state;
      var already = state && state.items && state.items.some(function (item) {
        return item.variant_id === giftId;
      });
      if (already) return;
      e.preventDefault();
      open();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cards = document.querySelectorAll('[data-ensemble]');
    cards.forEach(bind);
    /* Une seule fenêtre par page, rattachée à la première carte : c'est elle
       qui dit si l'achat est parti seul ou en ensemble. */
    if (cards.length) upsell(cards[0]);
  });
})();
